module.exports = __webpack_public_path__ + "img/operate2.aa29b995.png";